import { Link } from 'react-router-dom';
import { SafeHTML } from 'edrolo/domains/app';
import urlResolver from 'edrolo/utils/URLResolver';
import { ANALYTICS_CONSTANTS } from '../../constants';
import { useAnalytics } from 'edrolo/analytics';

import style from './NotebookItem.scss';

const NotebookItem = ({
  chunkTitle,
  chunkNote,
  classId,
  lessonId,
  chunkIndex,
  chunkId,
}: NotebookItemProps): JSX.Element => {
  const viewLessonPageLinkUrl = urlResolver.reverse('chunkview-chunk', {
    classId,
    lessonId,
    index: chunkIndex,
  });

  const { track } = useAnalytics({});

  const handleViewLesson = () => {
    track('view lesson page clicked', {
      origin: ANALYTICS_CONSTANTS.ORIGIN,
      page_name: ANALYTICS_CONSTANTS.PAGE_NAME,
      class_id: classId,
      lesson_id: lessonId,
      chunk_id: chunkId,
    });
  };
  return (
    <div className={style.notebookItemContainer}>
      <h4 className={style.chunkTitle}>{chunkTitle}</h4>
      <div className={style.chunkNotesWrapper}>
        <div className={style.viewLessonPageThumbnailUrl}>
          <Link to={viewLessonPageLinkUrl} onClick={handleViewLesson}>
            View lesson page
          </Link>
        </div>
        <div className={style.chunkNotes}>
          <SafeHTML>{chunkNote}</SafeHTML>
        </div>
      </div>
    </div>
  );
};

export default NotebookItem;

interface NotebookItemProps {
  chunkTitle: string;
  chunkNote: string;
  classId: ClassId;
  lessonId: string;
  chunkIndex: number;
  chunkId: number;
}
